// extracted by mini-css-extract-plugin
export default {"TocEntry":"PhotosToc_TocEntry__yI3RP","TocEntryMeta":"PhotosToc_TocEntryMeta__UZKau","TocEntryActive":"PhotosToc_TocEntryActive__SJ6fc","Toc":"PhotosToc_Toc__QjlFK"};